"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { ArrowLeft } from "@/components/icons";
import { PATH_BACK_LABELS } from "@/lib/constants";

export default function AuthorBackButton() {
  const router = useRouter();
  const [label, setLabel] = useState("Back to Blog");
  const [canGoBack, setCanGoBack] = useState(false);

  useEffect(() => {
    const prev = sessionStorage.getItem("prevPath");
    if (!prev) return;
    const path = prev.replace(/\/$/, "") || "/";
    const resolved = PATH_BACK_LABELS[path];
    if (resolved) setLabel(resolved);
    setCanGoBack(true);
  }, []);

  return (
    <button
      type="button"
      onClick={() => (canGoBack ? router.back() : router.push("/blog"))}
      className="text-muted-foreground hover:text-foreground mb-10 inline-flex cursor-pointer items-center gap-1.5 text-sm transition-colors"
    >
      <ArrowLeft size={14} />
      {label}
    </button>
  );
}
